import logo from "assets/images/logo.svg";
import "./ErrorScreen.scss";
import notification from "assets/images/icons/notification.svg";

const ErrorScreen = () => {
  return (


    <div className="error-container">
      <header className="main-header-error">
        <h1 className="main-header-error__logo-container">
          <img className="main-header-error__logo" src={logo} alt="Adyen Connector" />
        </h1> </header>
      <h1 className="error-title">
        <img src={notification} alt="notification" /> We’re currently experiencing technical issues</h1>
      <p className="error-message">
        {" Our team is already working to resolve them."}
        {"Please try again shortly."}
        {"For further information, reach out to Adyen Support: "} 
          <a href="https://help.adyen.com/knowledge/account/access-your-customer-area/how-do-i-reach-adyen-support">
            https://help.adyen.com/knowledge/account/access-your-customer-area/how-do-i-reach-adyen-support
          </a>
      </p>
    </div>
  );
};

export default ErrorScreen;